import React, { forwardRef, useEffect, useMemo, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Tabs,
  Tab,
  Box,
  Typography,
  Grid,
  IconButton,
  Tooltip,
  Chip,
  DialogActions,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { Settings } from "@mui/icons-material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";
import { IoMdArrowDropdown } from "react-icons/io";
import CloseIcon from "@mui/icons-material/Close";
import { Icons } from "../../doctor-console/Utils/iconsRegistry";
import axios from "axios";
import CreateAppointment from "../../appointments/CreateAppointment";
import { toast } from "react-toastify";
import SlotActionModal from "./SlotActionModal";
import Icon from "../../doctor-console/Utils/Icons";
import CancelAllModal from "./CancelAllModal";
import { isTodayOrFuture } from "../../utils/utils";
import { usePermissions } from "../../login/PermissionContext";
import showConfirmDialog from "../../../components/ShowConfirmDialog/ShowConfirmDialog";
import { displayPatientName } from "../../../utils/displayPatientName";
import {
  fetchDoctorConsultationServiceRow,
  fetchDoctorConsultationServiceRowById,
  formatInvoiceDateYmd,
  getConsultationUnitPriceStr,
  getSecuredApiHeaders,
  isInvoiceDateNotBeforeToday,
  resolveAppointmentInvoiceItemId,
  resolveConsultationUnitPriceStr,
  safeInvoiceNumber,
} from "../../appointments/appointmentInvoiceHelpers";

/** Maps doctor_slot / get_doctor_appointments `appointment_type` to radio values. */
function normalizeBackendVisitType(value) {
  if (value == null || value === "") return null;
  const v = String(value).trim().toUpperCase();
  if (v === "FIRST_VISIT" || v === "FOLLOW_UP" || v === "REPORT_VISIT") {
    return v;
  }
  return null;
}

/** Maps doctor_slot / get_doctor_appointments `appointment_mode` to radio values. */
function normalizeBackendAppointmentMode(value) {
  const v = String(value || "").trim().toUpperCase();
  return v === "ONLINE" || v === "OFFLINE" ? v : null;
}

/** Heading for reschedule visit-type radios: Slot # when available, else time range. */
function formatRescheduleVisitTypeHeading(slotInfo) {
  if (!slotInfo) return "Visit Type";
  const name =
    (slotInfo.patient_name && String(slotInfo.patient_name).trim()) ||
    "Patient";
  const raw = slotInfo.slot_number;
  if (raw != null && String(raw).trim() !== "") {
    const n = parseInt(String(raw), 10);
    const slotLabel = Number.isNaN(n) ? String(raw).trim() : String(n);
    return `Visit Type for ${name} (Slot #${slotLabel})`;
  }
  const st = slotInfo.slot_start_time;
  const en = slotInfo.slot_end_time;
  console.log("st", st);
  console.log("en", en);
  if (
    st != null &&
    en != null &&
    String(st).trim() !== "" &&
    String(en).trim() !== ""
  ) {
    return `Visit Type for ${name} (${String(st).trim()} - ${String(en).trim()})`;
  }
  return `Visit Type for ${name}`;
}

/**
 * `get_doctor_appointments/` often omits `slot_number`. After `doctor_slot/` loads,
 * find the occupied slot row for this appointment and use its `slot_number` / times.
 */
function findSlotByAppointmentIdInDoctorSlotData(shiftData, appointmentId) {
  if (!shiftData || appointmentId == null || appointmentId === "") return null;
  const id = String(appointmentId);
  const shiftKeys = ["first_shift", "second_shift", "third_shift"];
  for (const shiftKey of shiftKeys) {
    const block = shiftData[shiftKey];
    if (!block || typeof block !== "object") continue;
    for (const slots of Object.values(block)) {
      if (!Array.isArray(slots)) continue;
      for (const slot of slots) {
        if (
          slot &&
          slot.appointment_id != null &&
          String(slot.appointment_id) === id
        ) {
          return { slot, shiftKey };
        }
      }
    }
  }
  return null;
}

const DoctorSlotsModal = ({
  open,
  onClose,
  doctorId,
  // departmentId,
  setValue,
  //for create appointment
  isPatientOpen,
  preselectActivePatientOnOpen,
  handleClose,
  handleSubmit2,
  onSubmitSearch,
  register2,
  searchType,
  patients,
  selectedPatId,
  handleCardSelect,
  handleSubmit,
  // appointmentSubmit,
  register,
  // doctorId,
  doctorsList,
  errors,
  roleType,
  setselectedEmailId,
  appointmentModal,
  fetchDoctorAppointmentDetails,
  setReloadCalendar,
  sendEmail,
  handleCancelAppointment,
  initialRescheduleData = null,
  initialVisitType = 'FIRST_VISIT',
  parentAppointmentIdFromApi = null,
  isNewVisitLocked = false,
  isAppointmentTypeLoading = false,
  // departmentId,
}) => {
  const { userInfo } = usePermissions();
  const allow_backdate_appointment = userInfo?.allow_backdate_appointment;

  const [openCreateAppointment, setOpenCreateAppointment] = useState(false);
  /** From `get_medical_services/?doctor_id=` when the slots modal opens. */
  const [consultationMedicalService, setConsultationMedicalService] =
    useState(null);
  const [selectedShift, setSelectedShift] = useState("first_shift");
  const [selectedSlotForAppointment, setSelectedSlotForAppointment] =
    useState(null);
  const [dateForAppointment, setDateForAppointment] = useState(new Date());
  const [apiData, setApiData] = useState(null);
  const [openCancelAllModal, setOpenCancelAllModal] = useState(false);
  const [openSlotActionModal, setOpenSlotActionModal] = useState(false);
  const [slotInfo, setSlotInfo] = useState({});

  const [isRescheduleMode, setIsRescheduleMode] = useState(false);
  const [rescheduleSlotInfo, setRescheduleSlotInfo] = useState(null);
  const [selectedRescheduleSlot, setSelectedRescheduleSlot] = useState(null);

  const [rescheduleVisitType, setRescheduleVisitType] = useState("FIRST_VISIT");
  const [initialRescheduleVisitType, setInitialRescheduleVisitType] =
    useState("FIRST_VISIT");
  const [rescheduleMode, setRescheduleMode] = useState(null);
  const [initialRescheduleMode, setInitialRescheduleMode] = useState(null);
  const [rescheduleParentApptId, setRescheduleParentApptId] = useState(null);
  const [rescheduleNewVisitLocked, setRescheduleNewVisitLocked] =
    useState(false);
  const [isRescheduleVisitTypeLoading, setIsRescheduleVisitTypeLoading] =
    useState(false);
  const [isChangingRescheduleVisitType, setIsChangingRescheduleVisitType] =
    useState(false);
  const [lastCreateVisitTypeSyncKey, setLastCreateVisitTypeSyncKey] = useState("");

  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") || ""
  );

  /** Matches secured APIs: JWT + App-Mode, Org-Code, Username, User-Access-Key */
  const headers = useMemo(() => {
    const token =
      authToken || sessionStorage.getItem("accessToken") || "";
    const mode =
      sessionStorage.getItem("APP_MODE") ||
      sessionStorage.getItem("appMode") ||
      "";
    const org =
      sessionStorage.getItem("ORG_CODE") ||
      sessionStorage.getItem("orgCode") ||
      "";
    const username =
      sessionStorage.getItem("userName") ||
      sessionStorage.getItem("username") ||
      "";
    const accessKey =
      sessionStorage.getItem("USER_ACCESS_KEY") ||
      sessionStorage.getItem("accessKey") ||
      "";
    return {
      Authorization: `Bearer ${token}`,
      "App-Mode": mode,
      "Org-Code": org,
      Username: username,
      "User-Access-Key": accessKey,
    };
  }, [authToken]);
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;

  const shifts = [
    { label: "1st Shift", key: "first_shift" },
    { label: "2nd Shift", key: "second_shift" },
    { label: "3rd Shift", key: "third_shift" },
  ];

  // Fetch available slots based on the selected date
  const fetchSlotsData = async (date) => {
    // Local getters, not toISOString() — toISOString() converts to UTC first,
    // which rolls the date back a day for any timezone ahead of UTC (e.g. IST)
    // and desyncs the fetched slots from the date openCreateAppointmentHandler
    // below actually books against (that one already uses local getters).
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const payload = {
      appointment_date: `${year}-${month}-${day}`,
      doctor_id: doctorId,
      // department_id: departmentId,
    };

    try {
      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}doctor_slot/`,
        payload,
        { headers }
      );
      setApiData(response.data); // Set the response data

      const data = response.data?.data || {};

      // Determine which shift has slots
      const shiftOrder = ["first_shift", "second_shift", "third_shift"];
      const firstAvailableShift = shiftOrder.find(
        (shift) => data[shift] && Object.keys(data[shift]).length > 0
      );

      if (firstAvailableShift) {
        setSelectedShift(firstAvailableShift);
      }
    } catch (error) {
      console.error("Error fetching slots data:", error);
    }
  };
  console.log("dateForAppointment", dateForAppointment);

  useEffect(() => {
    if (open) {
      fetchSlotsData(dateForAppointment); // Fetch data when the modal opens
    }
  }, [open, dateForAppointment]); // Trigger when modal opens or date changes

  useEffect(() => {
    if (!open) {
      setConsultationMedicalService(null);
      return;
    }
    let cancelled = false;
    const run = async () => {
      if (!authToken) return;
      try {
        const doctorIdforDoctor = sessionStorage.getItem("doctor_id");
        const isDoctor = roleType === "doctor";
        const resolvedDoctorId = isDoctor ? doctorIdforDoctor : doctorId;
        const row = await fetchDoctorConsultationServiceRow(
          axios,
          REACT_APP_BACKEND_ROUTE_URL,
          headers,
          resolvedDoctorId,
          "FIRST_VISIT",
        );
        if (cancelled) return;
        setConsultationMedicalService(row);
      } catch (err) {
        if (!cancelled) {
          console.error("get_medical_services failed:", err);
          setConsultationMedicalService(null);
        }
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [open, authToken, REACT_APP_BACKEND_ROUTE_URL, roleType, doctorId, headers]);

  useEffect(() => {
    // For create flow, always recompute visit type against the currently selected
    // slot date whenever date/patient changes.
    if (!open || isRescheduleMode || !selectedPatId) {
      if (!open || isRescheduleMode) {
        setLastCreateVisitTypeSyncKey("");
      }
      return;
    }
    const year = dateForAppointment.getFullYear();
    const month = String(dateForAppointment.getMonth() + 1).padStart(2, "0");
    const day = String(dateForAppointment.getDate()).padStart(2, "0");
    const syncKey = `${selectedPatId}|${year}-${month}-${day}`;
    if (syncKey === lastCreateVisitTypeSyncKey) {
      return;
    }
    setLastCreateVisitTypeSyncKey(syncKey);
    handleCardSelect(selectedPatId, dateForAppointment);
  }, [
    open,
    isRescheduleMode,
    selectedPatId,
    dateForAppointment,
    lastCreateVisitTypeSyncKey,
    handleCardSelect,
  ]);

  useEffect(() => {
    if (!open) {
      // Full cleanup when the slots modal closes so reschedule/create state
      // does not leak to the next open (e.g. another patient's edit).
      setIsRescheduleMode(false);
      setRescheduleSlotInfo(null);
      setSelectedRescheduleSlot(null);
      setRescheduleVisitType("FIRST_VISIT");
      setInitialRescheduleVisitType("FIRST_VISIT");
      setRescheduleParentApptId(null);
      setRescheduleNewVisitLocked(false);
      setIsRescheduleVisitTypeLoading(false);
      setIsChangingRescheduleVisitType(false);
      setSelectedSlotForAppointment(null);
      setOpenCreateAppointment(false);
      setSlotInfo({});
      setOpenSlotActionModal(false);
      if (typeof setValue === "function") {
        setValue("appointment_start_time", "");
        setValue("appointment_end_time", "");
      }
      return;
    }

    if (initialRescheduleData) {
      // New reschedule session — do not keep a previously selected free slot.
      setSelectedRescheduleSlot(null);
      setIsRescheduleMode(true);
      setRescheduleSlotInfo(initialRescheduleData);
      const fromList = normalizeBackendVisitType(
        initialRescheduleData.appointment_type
      );
      if (fromList) {
        setRescheduleVisitType(fromList);
        setInitialRescheduleVisitType(fromList);
      } else {
        setRescheduleVisitType("FIRST_VISIT");
        setInitialRescheduleVisitType("FIRST_VISIT");
      }
      const modeFromList = normalizeBackendAppointmentMode(
        initialRescheduleData.appointment_mode
      );
      setRescheduleMode(modeFromList);
      setInitialRescheduleMode(modeFromList);
    } else {
      // Open in normal mode when no reschedule data
      setIsRescheduleMode(false);
      setRescheduleSlotInfo(null);
      setSelectedRescheduleSlot(null);
      setRescheduleVisitType("FIRST_VISIT");
      setInitialRescheduleVisitType("FIRST_VISIT");
      setRescheduleMode(null);
      setInitialRescheduleMode(null);
      setRescheduleParentApptId(null);
      setRescheduleNewVisitLocked(false);
      setIsRescheduleVisitTypeLoading(false);
      setIsChangingRescheduleVisitType(false);
    }
  }, [open, initialRescheduleData, setValue]);

  useEffect(() => {
    if (!open || !isRescheduleMode || !apiData?.data) return;
    const apptId = rescheduleSlotInfo?.appointment_id;
    if (apptId == null || apptId === "") return;

    const result = findSlotByAppointmentIdInDoctorSlotData(
      apiData.data,
      apptId
    );
    if (!result) return;

    const { slot: found, shiftKey } = result;
    setSelectedShift(shiftKey);

    setRescheduleSlotInfo((prev) => {
      if (!prev || String(prev.appointment_id) !== String(apptId)) return prev;
      const next = { ...prev };
      let changed = false;
      if (
        (next.slot_number == null || String(next.slot_number).trim() === "") &&
        found.slot_number != null &&
        String(found.slot_number).trim() !== ""
      ) {
        next.slot_number = found.slot_number;
        changed = true;
      }
      if (
        (next.slot_start_time == null ||
          String(next.slot_start_time).trim() === "") &&
        found.slot_start_time
      ) {
        next.slot_start_time = found.slot_start_time;
        changed = true;
      }
      if (
        (next.slot_end_time == null || String(next.slot_end_time).trim() === "") &&
        found.slot_end_time
      ) {
        next.slot_end_time = found.slot_end_time;
        changed = true;
      }
      return changed ? next : prev;
    });
  }, [open, isRescheduleMode, apiData, rescheduleSlotInfo?.appointment_id]);

  useEffect(() => {
    if (!open || !isRescheduleMode || !doctorId) {
      return;
    }
    const patientId = rescheduleSlotInfo?.patient_id;
    if (!patientId) {
      setRescheduleParentApptId(null);
      setRescheduleNewVisitLocked(false);
      setIsRescheduleVisitTypeLoading(false);
      const t = normalizeBackendVisitType(
        rescheduleSlotInfo?.appointment_type
      );
      if (t) {
        setRescheduleVisitType(t);
        setInitialRescheduleVisitType(t);
      } else {
        setRescheduleVisitType("FIRST_VISIT");
        setInitialRescheduleVisitType("FIRST_VISIT");
      }
      return;
    }

    setIsRescheduleVisitTypeLoading(true);
    const year = dateForAppointment.getFullYear();
    const month = String(dateForAppointment.getMonth() + 1).padStart(2, "0");
    const day = String(dateForAppointment.getDate()).padStart(2, "0");

    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}get_patient_appointment_type/`,
        {
          doctor_id: doctorId,
          patient_id: patientId,
          appointment_date: `${year}-${month}-${day}`,
          existing_appointment_id: rescheduleSlotInfo?.appointment_id ?? null,
        },
        { headers }
      )
      .then((response) => {
        if (response.data.status === "Success") {
          const followupVisit = !!response.data?.data?.followup_visit;
          const parentId =
            response.data?.data?.parent_appointment_id ?? null;

          if (!followupVisit && parentId === null) {
            setRescheduleNewVisitLocked(true);
            setRescheduleParentApptId(null);
            setRescheduleVisitType("FIRST_VISIT");
            setInitialRescheduleVisitType("FIRST_VISIT");
          } else {
            setRescheduleNewVisitLocked(false);
            setRescheduleParentApptId(parentId);

            const fromAppt = normalizeBackendVisitType(
              rescheduleSlotInfo?.appointment_type
            );
            if (fromAppt) {
              // Keep baseline aligned with backend/default selection.
              setInitialRescheduleVisitType(fromAppt);
            }
            if (!fromAppt) {
              if (!followupVisit && parentId !== null) {
                setRescheduleVisitType("FIRST_VISIT");
                setInitialRescheduleVisitType("FIRST_VISIT");
              } else if (followupVisit) {
                setRescheduleVisitType("FOLLOW_UP");
                setInitialRescheduleVisitType("FOLLOW_UP");
              } else {
                setRescheduleVisitType("FIRST_VISIT");
                setInitialRescheduleVisitType("FIRST_VISIT");
              }
            }
          }
        } else {
          setRescheduleParentApptId(null);
          setRescheduleNewVisitLocked(false);
          if (!normalizeBackendVisitType(rescheduleSlotInfo?.appointment_type)) {
            setRescheduleVisitType("FIRST_VISIT");
            setInitialRescheduleVisitType("FIRST_VISIT");
          }
        }
      })
      .catch(() => {
        setRescheduleParentApptId(null);
        setRescheduleNewVisitLocked(false);
        if (!normalizeBackendVisitType(rescheduleSlotInfo?.appointment_type)) {
          setRescheduleVisitType("FIRST_VISIT");
          setInitialRescheduleVisitType("FIRST_VISIT");
        }
      })
      .finally(() => {
        setIsRescheduleVisitTypeLoading(false);
      });
  }, [
    open,
    isRescheduleMode,
    doctorId,
    rescheduleSlotInfo?.patient_id,
    rescheduleSlotInfo?.appointment_id,
    rescheduleSlotInfo?.appointment_type,
    dateForAppointment,
  ]);

  const cancelAppointmentHandler = async (appointmentId) => {
    await handleCancelAppointment(appointmentId); // wait for cancel to complete
    await fetchSlotsData(dateForAppointment); // call fetchSlotsData after the cancel operation is finished
  };

  const formatTime = (time) => {
    const [hour, minute] = time.split(":");
    let h = parseInt(hour);
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${h}:${minute} ${ampm}`;
  };

  const openCreateAppointmentHandler = (startTime, endTime, slotNumber) => {
    // Extract the date part (keeping only the year, month, day)
    const year = dateForAppointment.getFullYear();
    const month = String(dateForAppointment.getMonth() + 1).padStart(2, "0"); // getMonth() returns 0-11
    const day = String(dateForAppointment.getDate()).padStart(2, "0"); // Add padding if single digit

    // Set the start and end times
    const startDateTime = `${year}-${month}-${day}T${startTime}`;
    const endDateTime = `${year}-${month}-${day}T${endTime}`;

    setValue("appointment_start_time", startDateTime);
    setValue("appointment_end_time", endDateTime);

    setSelectedSlotForAppointment(slotNumber);

    // Pre-select the global active patient (from the top search context) so it
    // stays chosen when the create-appointment modal is reopened for a slot.
    if (typeof preselectActivePatientOnOpen === "function") {
      preselectActivePatientOnOpen();
    }

    setOpenCreateAppointment(true);
  };

  const openSlotActionModalHandler = (
    startTime,
    endTime,
    slotNumber,
    patientId,
    patientName,
    appointmentId,
    appointmentType = null,
    appointmentMode = null
  ) => {
    setSlotInfo({
      slot_start_time: startTime,
      slot_end_time: endTime,
      slot_number: slotNumber,
      slot_date: dateForAppointment.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }),
      patient_id: patientId,
      patient_name: patientName,
      appointment_id: appointmentId,
      appointment_type: appointmentType,
      appointment_mode: appointmentMode,
    });
    setOpenSlotActionModal(true);
  };

  const appointmentSubmit = async (data, e, opts) => {
    e.preventDefault();
    console.log(data, "data..");

    const doctorIdforDoctor = sessionStorage.getItem("doctor_id");
    const isDoctor = roleType === "doctor";
    const resolvedDoctorId = isDoctor ? doctorIdforDoctor : doctorId;
    const visitType = data.appointment_type || "FIRST_VISIT";

    let visitFeeServiceRow = opts?.selectedFeeServiceRow || null;
    if (!visitFeeServiceRow && data.medical_service_id) {
      try {
        visitFeeServiceRow = await fetchDoctorConsultationServiceRowById(
          axios,
          REACT_APP_BACKEND_ROUTE_URL,
          headers,
          resolvedDoctorId,
          data.medical_service_id,
        );
      } catch (err) {
        console.error("get_medical_services (selected fee):", err);
      }
    }
    if (!visitFeeServiceRow) {
      try {
        visitFeeServiceRow = await fetchDoctorConsultationServiceRow(
          axios,
          REACT_APP_BACKEND_ROUTE_URL,
          headers,
          resolvedDoctorId,
          visitType,
        );
      } catch (err) {
        console.error("get_medical_services (visit fee):", err);
      }
    }

    if (!visitFeeServiceRow) {
      const feeLabel =
        visitType === "FOLLOW_UP"
          ? "Follow up fee"
          : visitType === "REPORT_VISIT"
            ? "Report Visit fee"
            : "Consultation fee";
      toast.error(
        `No ${feeLabel} service is configured for this doctor. Please add it under Available Services.`,
      );
      return;
    }

    const consultationPriceStr = getConsultationUnitPriceStr(
      resolvedDoctorId,
      doctorsList,
      visitFeeServiceRow?.price
    );

    const newData = {
      ...data,
      new_patient: false,
      ...(isDoctor
        ? { doctor_id: doctorIdforDoctor }
        : { doctor_id: doctorId }),
      patient_id: selectedPatId,
      status: "SCHEDULED",
      shift: selectedShift.split("_")[0],
      slot_number: selectedSlotForAppointment,
      ...(visitFeeServiceRow?.service_id != null ||
      visitFeeServiceRow?.item_id != null
        ? {
            medical_service_id:
              visitFeeServiceRow.service_id ??
              String(visitFeeServiceRow.item_id),
            fee: consultationPriceStr,
          }
        : {}),
    };

    if (newData.appointment_type === "FIRST_VISIT") {
      newData.parent_appointment_id = null;
    }

    console.log(newData, "newdata");

    // Validation
    if (!newData.patient_id) {
      toast.error("Please select a patient");
      return;
    }

    const startDate = new Date(newData.appointment_start_time);
    const endDate = new Date(newData.appointment_end_time);

    const isSameDay =
      startDate.getFullYear() === endDate.getFullYear() &&
      startDate.getMonth() === endDate.getMonth() &&
      startDate.getDate() === endDate.getDate();

    if (!isSameDay) {
      toast.error("Start and end time must be on the same day");
      return;
    }

    if (endDate <= startDate) {
      toast.error("End time must be after start time");
      return;
    }

    try {
      // Create Appointment
      const appointmentRes = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}add_appointment/`,
        JSON.stringify(newData),
        { headers: headers }
      );

      if (appointmentRes.data.status !== "Success") {
        fetchSlotsData();
        toast.error(
          appointmentRes.data.message || "Failed to create appointment"
        );
        return appointmentRes.data;
      } else {
        let createdInvoiceNumber = null;
        const serviceRow = visitFeeServiceRow;
        let invoiceToastSuffix = "";
        let zeroFeeAutoPaid = false;

        // Appointment's string id from the create response — links the invoice
        // line to the appointment so a later cancellation can auto-raise a refund.
        const createdAppointmentId =
          appointmentRes.data?.appointment_id ??
          appointmentRes.data?.data?.appointment_id ??
          null;

        if (opts?.collectPayment) {
          const priceStr = resolveConsultationUnitPriceStr(
            newData.doctor_id,
            doctorsList,
            serviceRow?.price,
          );
          const isZeroFee =
            priceStr != null && safeInvoiceNumber(priceStr) === 0;

          // Fee ₹0 (typical Follow-up / Report Visit): no invoice, no payment
          // modal — only mark appointment payment status as PAID.
          if (isZeroFee && createdAppointmentId) {
            try {
              const paidRes = await axios.post(
                `${REACT_APP_BACKEND_ROUTE_URL}change_payment_status/`,
                {
                  appointment_id: createdAppointmentId,
                  payment_status: "PAID",
                  payment_amount: "0.00",
                  payment_mode: "CASH",
                },
                { headers: getSecuredApiHeaders(authToken) },
              );
              if (String(paidRes?.data?.status || "") === "Success") {
                zeroFeeAutoPaid = true;
                invoiceToastSuffix =
                  " Marked as paid (₹0 — no invoice required).";
              } else {
                toast.warning(
                  paidRes?.data?.message ||
                    "Appointment created, but payment status could not be updated to PAID.",
                );
              }
            } catch (paidErr) {
              console.error("change_payment_status (zero fee):", paidErr);
              toast.warning(
                paidErr?.response?.data?.message ||
                  "Appointment created, but payment status could not be updated to PAID.",
              );
            }
          } else {
            const invoiceItemId = resolveAppointmentInvoiceItemId(serviceRow);
            if (invoiceItemId != null) {
              const hip_id = sessionStorage.getItem("facility_name");
              const invoice_date = formatInvoiceDateYmd(
                newData.appointment_start_time,
              );
              if (!hip_id) {
                toast.warning(
                  "Appointment created. Invoice was not created: facility is not configured for this session.",
                );
              } else if (!invoice_date) {
                toast.warning(
                  "Appointment created. Invoice was not created: invalid appointment start time.",
                );
              } else if (!isInvoiceDateNotBeforeToday(invoice_date)) {
                toast.warning(
                  "Appointment created. Invoice was not created: invoice date cannot be in the past.",
                );
              } else if (!priceStr) {
                toast.warning(
                  "Appointment created. Invoice was not created: consultation fee is not configured for this doctor or service.",
                );
              } else {
                const invoiceBody = {
                  hip_id: String(hip_id),
                  invoice_date,
                  patient_id: String(newData.patient_id),
                  ...(createdAppointmentId
                    ? { appointment_id: createdAppointmentId }
                    : {}),
                  note: "",
                  gst_number: "",
                  partial_payment: "0.00",
                  tax: "0",
                  item: {
                    item_id: invoiceItemId,
                    doctor_id: String(newData.doctor_id),
                    quantity: 1,
                    price: priceStr,
                  },
                };
                try {
                  const invRes = await axios.post(
                    `${REACT_APP_BACKEND_ROUTE_URL}create_appointment_invoice/`,
                    invoiceBody,
                    {
                      headers: {
                        ...headers,
                        "Content-Type": "application/json",
                      },
                    },
                  );
                  const inv = invRes.data;
                  if (String(inv?.status || "").toLowerCase() === "success") {
                    createdInvoiceNumber =
                      inv.invoice_number || inv.invoice_no || null;
                    invoiceToastSuffix = inv.invoice_number
                      ? ` Invoice ${inv.invoice_number} created.`
                      : ` ${inv.message || "Invoice created."}`;
                  } else {
                    toast.warning(
                      inv?.message ||
                        "Appointment created, but the invoice could not be created.",
                    );
                  }
                } catch (invErr) {
                  console.error("create_appointment_invoice:", invErr);
                  const msg =
                    invErr?.response?.data?.message ||
                    "Appointment created, but the invoice request failed.";
                  toast.warning(msg);
                }
              }
            } else {
              toast.warning(
                "Appointment created. Invoice was not created: no matching fee service exists for this visit type.",
              );
            }
          }
        }

        toast.success(
          "Appointment scheduled successfully." + invoiceToastSuffix,
        );

        // UI updates
        fetchDoctorAppointmentDetails();
        setReloadCalendar((prev) => !prev);
        sendEmail(newData);
        if (!opts || !opts.skipClose) {
          handleClose();
          fetchSlotsData(dateForAppointment);
          setOpenCreateAppointment(false);
        } else {
          fetchSlotsData(dateForAppointment);
        }
        return {
          ...appointmentRes.data,
          ...(createdInvoiceNumber
            ? { invoice_number: createdInvoiceNumber }
            : {}),
          ...(zeroFeeAutoPaid ? { zero_fee_auto_paid: true } : {}),
          ...(visitFeeServiceRow?.service_id || visitFeeServiceRow?.item_id
            ? {
                medical_service_id:
                  visitFeeServiceRow.service_id ??
                  String(visitFeeServiceRow.item_id),
                consultation_service_row: visitFeeServiceRow,
              }
            : {}),
        };
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error(
        "An unexpected error occurred while scheduling the appointment"
      );
      return { status: "Error", message: "Unexpected error" };
    }
  };

  const handleRescheduleVisitTypeChange = async (event) => {
    const nextType = event.target.value;
    if (nextType === rescheduleVisitType) return;
    if (rescheduleNewVisitLocked) return;

    const patientId = rescheduleSlotInfo?.patient_id;
    if (!patientId) {
      setRescheduleVisitType(nextType);
      return;
    }

    setIsChangingRescheduleVisitType(true);
    try {
      const ok = await showConfirmDialog(
        "Are you sure you want to change it?"
      );
      if (ok) {
        setRescheduleVisitType(nextType);
      }
    } finally {
      setIsChangingRescheduleVisitType(false);
    }
  };

  const handleRescheduleAppointment = async () => {
    if (!rescheduleSlotInfo) return;
    const targetSlot = selectedRescheduleSlot || rescheduleSlotInfo;

    const appointment_type = rescheduleVisitType;
    let parent_appointment_id =
      appointment_type === "FIRST_VISIT" ? null : rescheduleParentApptId;

    if (appointment_type !== "FIRST_VISIT" && !parent_appointment_id) {
      toast.error(
        "Parent appointment is required for Follow up/Report visits"
      );
      return;
    }

    // Extract the date part (keeping only the year, month, day)
    const year = dateForAppointment.getFullYear();
    const month = String(dateForAppointment.getMonth() + 1).padStart(2, "0"); // getMonth() returns 0-11
    const day = String(dateForAppointment.getDate()).padStart(2, "0"); // Add padding if single digit

    // Set the start and end times
    if (!targetSlot?.slot_start_time || !targetSlot?.slot_end_time) {
      toast.error("Please select a slot to reschedule");
      return;
    }

    const startDateTime = `${year}-${month}-${day}T${targetSlot.slot_start_time}`;
    const endDateTime = `${year}-${month}-${day}T${targetSlot.slot_end_time}`;

    try {
      const payload = {
        doctor_id: doctorId,
        appointment_start_time: startDateTime,
        appointment_end_time: endDateTime,
        appointment_id: rescheduleSlotInfo.appointment_id,
        shift: selectedShift.split("_")[0],
        slot_number: targetSlot.slot_number,
        appointment_type,
        parent_appointment_id,
      };

      if (appointment_type === "FIRST_VISIT") {
        payload.parent_appointment_id = null;
      }

      if (rescheduleMode) {
        payload.appointment_mode = rescheduleMode;
      }

      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}edit_appointment/`,
        payload,
        { headers }
        // {
        //   headers, // your headers
        //   data: payload, //  payload goes here
        // }
      );

      if (response?.data?.status === "Success") {
        toast.success("Appointment rescheduled successfully");

        // refresh UI and reset
        fetchDoctorAppointmentDetails();
        setReloadCalendar((prev) => !prev);
        fetchSlotsData(dateForAppointment);
        resetRescheduleMode();
        if (initialRescheduleData) {
          onClose();
        }
      } else {
        // console.log(response)
        toast.error("Some error occured while rescheduling the appointment!");
      }
    } catch (error) {
      console.error("Error rescheduling:", error);
      toast.error("Failed to reschedule appointment");
    }
  };

  const resetRescheduleMode = () => {
    setIsRescheduleMode(false);
    setRescheduleSlotInfo(null);
    setSelectedRescheduleSlot(null);
    setRescheduleVisitType("FIRST_VISIT");
    setInitialRescheduleVisitType("FIRST_VISIT");
    setRescheduleMode(null);
    setInitialRescheduleMode(null);
    setRescheduleParentApptId(null);
    setRescheduleNewVisitLocked(false);
    setIsRescheduleVisitTypeLoading(false);
    setIsChangingRescheduleVisitType(false);
  };

  const renderSlots = (shiftData) => {
    // Check if status is 'Failed'
    if (
      apiData?.status === "Failed"
      // && apiData?.message?.includes("No Schedules found for this Doctor")
    ) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%", // take up full container height
            minHeight: "200px", // fallback height if parent isn't full-height
            textAlign: "center",
          }}
        >
          {apiData?.message?.includes("No Schedules found for this Doctor") ? (
            <Typography variant="body1" color="error" sx={{ fontWeight: 500 }}>
              No Schedules found for this Doctor! Please Contact Administrator
            </Typography>
          ) : (
            <Typography
              variant="body1"
              color="#0e204d"
              sx={{ fontWeight: 500 }}
            >
              {apiData?.message}
            </Typography>
          )}
        </Box>
      );
    }

    if (!shiftData || Object.keys(shiftData).length === 0) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%", // take up full container height
            minHeight: "200px", // fallback height if parent isn't full-height
            textAlign: "center",
          }}
        >
          <Typography variant="body1" color="#0e204d" sx={{ fontWeight: 500 }}>
            No schedule available for this shift.
          </Typography>
        </Box>
      );
    }

    return Object.entries(shiftData).map(([hourRange, slots], idx) => {
      const [startHour, endHour] = hourRange.split("–");
      return (
        <Box
          key={idx}
          sx={{
            border: "1px solid #ddd",
            borderRadius: "10px",
            p: 1.5,
            mb: 2,
            position: "relative",
            maxWidth: "100%",
            mx: "auto",
          }}
        >
          {/* Hour Range Label */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 0.5,
              px: 0.5,
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 600, color: "#444" }}
            >
              {formatTime(startHour)}
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 600, color: "#444" }}
            >
              {formatTime(endHour)}
            </Typography>
          </Box>

          {/* Slot Boxes */}
          <Box
            sx={{
              display: "flex",
              overflowX: "auto",
              gap: "8px",
              maxWidth: "100%",
            }}
          >
            {slots.length > 0 ? (
              slots.map((slot) => {
                const isFree = slot.status === "free";
                const isCompleted = slot.status === "completed";
                // New appointments require a matching "{Doctor} Consultation fees"
                // service; reschedules don't create a new invoice, so they're unaffected.
                const isBlockedByMissingService =
                  isFree && !isRescheduleMode && !consultationMedicalService;
                const isBookable = isFree && !isBlockedByMissingService;
                return (
                  <Box
                    key={slot.slot_number}
                    onClick={() => {
                      if (isBlockedByMissingService) {
                        toast.warning(
                          "No consultation service exists for the selected doctor."
                        );
                        return;
                      }
                      if (!isFree) return;
                      if (isRescheduleMode) {
                        setSelectedRescheduleSlot(slot);
                      } else {
                        if (allow_backdate_appointment) {
                          openCreateAppointmentHandler(
                            slot.slot_start_time,
                            slot.slot_end_time,
                            slot.slot_number
                          );
                        } else {
                          if (isTodayOrFuture(dateForAppointment)) {
                            //only allow if its not past
                            openCreateAppointmentHandler(
                              slot.slot_start_time,
                              slot.slot_end_time,
                              slot.slot_number
                            );
                          } else {
                            toast.error("You are not allowed to create an appointment for a past date");
                          }
                        }
                        // }
                      }
                    }}
                    sx={{
                      width: "calc(100% / 7)",
                      minWidth: "129px",
                      height: 100,
                      backgroundColor: isCompleted
                        ? "#B3DF77"
                        : isBlockedByMissingService
                          ? "#E0E0E0"
                          : isBookable
                            ? selectedRescheduleSlot?.slot_number ===
                              slot.slot_number
                              ? "#B2F0E9"
                              : "#EBFAF9"
                            : "#125386",
                      color: isBookable || isCompleted
                        ? "#0E3F66"
                        : isBlockedByMissingService
                          ? "#9E9E9E"
                          : "#FFFFFF",
                      borderRadius: "10px",
                      border: isCompleted
                        ? "1px solid #A1DA3B"
                        : isBlockedByMissingService
                          ? "1px solid #BDBDBD"
                          : isBookable
                            ? "1px solid #21CDC0"
                            : "1px solid #0E3F66",
                      position: "relative",
                      p: 1,
                      textAlign: "center",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                      cursor: isBlockedByMissingService
                        ? "not-allowed"
                        : isBookable
                          ? "pointer"
                          : "default",
                      transition:
                        "background-color 0.3s ease, box-shadow 0.3s ease",
                      "&:hover": {
                        backgroundColor: isCompleted
                          ? "#B3DF77"
                          : isBlockedByMissingService
                            ? "#E0E0E0"
                            : isBookable
                              ? "#ddf8f6ff"
                              : "#121959",
                        boxShadow: isBookable
                          ? "0 4px 6px rgba(0, 0, 0, 0.1)"
                          : "0 1px 3px rgba(0,0,0,0.1)",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 0.5,
                      }}
                    >
                      <IconButton
                        size="small"
                        disabled={isFree}
                        sx={{
                          cursor: isFree ? "pointer" : "default",
                          "& .MuiSvgIcon-root": {
                            color: "white", // Override icon color to white
                          },
                        }}
                        onClick={() =>
                          !isFree &&
                            !isCompleted &&
                            allow_backdate_appointment ?
                            openSlotActionModalHandler(
                              slot?.slot_start_time,
                              slot?.slot_end_time,
                              slot?.slot_number,
                              slot?.patient_id,
                              slot?.patient_name,
                              slot?.appointment_id,
                              slot?.appointment_type,
                              slot?.appointment_mode
                            ) :
                            isTodayOrFuture(dateForAppointment) && //only allow if its not past
                            openSlotActionModalHandler(
                              slot?.slot_start_time,
                              slot?.slot_end_time,
                              slot?.slot_number,
                              slot?.patient_id,
                              slot?.patient_name,
                              slot?.appointment_id,
                              slot?.appointment_type,
                              slot?.appointment_mode
                            )
                        }
                      >
                        <Icon
                          name={
                            isFree
                              ? "slotSettingsActive"
                              : "slotSettingsInactive"
                          }
                          size={24}
                        />
                      </IconButton>

                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                      >
                      {!isFree &&
                        normalizeBackendAppointmentMode(
                          slot?.appointment_mode
                        ) === "ONLINE" && (
                          <Tooltip title="Online appointment">
                            <Box sx={{ display: "flex" }}>
                              <Icon name="tele" size={18} />
                            </Box>
                          </Tooltip>
                        )}
                      <Chip
                        label={`#${slot.slot_number}`}
                        size="small"
                        sx={{
                          height: 20,
                          fontSize: "0.7rem",
                          borderRadius: "6px",
                          fontWeight: 500,
                          backgroundColor: isCompleted
                            ? "#017B40"
                            : isFree
                              ? "#1172D7"
                              : "#A5DEFF", // custom background
                          "& .MuiChip-label": {
                            color:
                              isFree || isCompleted ? "#FFFFFF" : "#0E3F66", // dynamic label color
                          },
                        }}
                      />
                      </Box>
                    </Box>

                    <Typography
                      variant="body2"
                      fontWeight={600}
                      sx={{ lineHeight: 1.2 }}
                    >
                      {slot.slot_start_time} - {slot.slot_end_time}
                    </Typography>
                    {/* <Typography
                      variant="caption"
                      color={isFree ? "#000000" : "#FFFFFF"}
                    >
                      {isFree ? "Available" : "Booked"}
                    </Typography>
                    <Typography
                      variant="inherit"
                      color={isFree ? "#000000" : "#FFFFFF"}
                    >
                      <b>{isFree ? "—" : slot?.patient_name}</b>
                    </Typography> */}
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography
                        variant="caption"
                        color={
                          isBlockedByMissingService
                            ? "#9E9E9E"
                            : isFree || isCompleted
                              ? "#0E3F66"
                              : "#FFFFFF"
                        }
                        sx={{ lineHeight: 1.0 }}
                      >
                        {isCompleted
                          ? "Completed"
                          : isBlockedByMissingService
                            ? "Unavailable"
                            : isFree
                              ? "Available"
                              : "Booked"}
                      </Typography>
                      <Typography
                        variant="caption"
                        color={isFree || isCompleted ? "#0E3F66" : "#FFFFFF"}
                        sx={{ lineHeight: 1.0 }}
                      >
                        <b>
                          {isFree ? "—" : displayPatientName(slot?.patient_name)}
                        </b>
                      </Typography>
                    </Box>
                  </Box>
                );
              })
            ) : (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ ml: 2, mt: 1 }}
              >
                Doctor unavailable in this hour
              </Typography>
            )}
          </Box>
        </Box>
      );
    });
  };

  const hasRescheduleVisitTypeChanged =
    isRescheduleMode && rescheduleVisitType !== initialRescheduleVisitType;
  const hasRescheduleModeChanged =
    isRescheduleMode && rescheduleMode !== initialRescheduleMode;

  return (
    <>
      <CancelAllModal
        open={openCancelAllModal}
        onClose={() => {
          setOpenCancelAllModal(false);
        }}
        doctorId={doctorId}
        functionsOnSuccess={() => {
          fetchDoctorAppointmentDetails();
          fetchSlotsData(dateForAppointment);
        }}
      />
      <SlotActionModal
        open={openSlotActionModal}
        onClose={() => {
          setOpenSlotActionModal(false);
        }}
        handleCancelAppointment={(appointmentId) =>
          cancelAppointmentHandler(appointmentId)
        }
        onReschedule={(info) => {
          setIsRescheduleMode(true);
          setRescheduleSlotInfo(info);
          const t = normalizeBackendVisitType(info?.appointment_type);
          if (t) {
            setRescheduleVisitType(t);
          } else {
            setRescheduleVisitType("FIRST_VISIT");
          }
          const mode = normalizeBackendAppointmentMode(info?.appointment_mode);
          setRescheduleMode(mode);
          setInitialRescheduleMode(mode);
          setOpenSlotActionModal(false);
        }}
        slotInfo={slotInfo}
      />

      <CreateAppointment
        isPatientOpen={openCreateAppointment}
        handleClose={() => {
          setOpenCreateAppointment(false);
          handleClose();
        }}
        handleSubmit2={handleSubmit2}
        onSubmitSearch={onSubmitSearch}
        setselectedEmailId={setselectedEmailId}
        register2={register2}
        searchType={searchType}
        patients={patients}
        selectedPatId={selectedPatId}
        handleCardSelect={(patId) => handleCardSelect(patId, dateForAppointment)}
        handleSubmit={handleSubmit}
        appointmentSubmit={appointmentSubmit}
        register={register}
        doctorId={doctorId}
        doctorsList={doctorsList}
        errors={errors}
        roleType={roleType}
        appointmentModal={appointmentModal}
        onPaymentModalClose={fetchDoctorAppointmentDetails}
        initialVisitType={initialVisitType}
        parentAppointmentIdFromApi={parentAppointmentIdFromApi}
        isNewVisitLocked={isNewVisitLocked}
        isAppointmentTypeLoading={isAppointmentTypeLoading}
        consultationMedicalService={consultationMedicalService}
      // departmentId={departmentId}
      />
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "12px",
            width: "71%",
            minHeight: "70vh",
            overflowY: "auto",
          },
        }}
      >
        <DialogTitle
          sx={{
            // backgroundImage: `url(${Icons.modal_blue})`,
            backgroundColor: "#213360",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            className="main-title"
            style={{
              textAlign: "center",
              color: "#FFFFFF",
              margin: "0px",
              fontSize: "20px",
            }}
          >
            {isRescheduleMode
              ? "Reschedule Appointment"
              : "Doctor Appointment Slots"}
          </div>
          <IconButton onClick={onClose}>
            <CloseIcon
              sx={{
                color: "#FFFFFF",
                fontSize: { xs: "1.2rem", sm: "1.5rem" },
              }}
            />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          {/* Header Section */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={1.5}
          >
            <Box display="flex" alignItems="center" gap={2}>
              <DatePicker
                selected={dateForAppointment}
                onChange={(date) => setDateForAppointment(date)}
                dateFormat="dd MMM"
                customInput={<CustomDateInput />}
              />
              {/* <Typography variant="subtitle1">
                Date:{" "}
                {dateForAppointment.toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })}{" "}
                (
                {dateForAppointment.toLocaleDateString("en-GB", {
                  weekday: "long",
                })}
                )
              </Typography> */}

              {!isRescheduleMode && (
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#ffffff",
                    border: "1px solid rgb(204, 204, 204)",
                    boxShadow: "none",
                    borderRadius: "9999px",
                    textTransform: "none",
                    color: "#1a2942",
                    padding: "6px 12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    "&:hover": {
                      backgroundColor: "#f5f7fa",
                      boxShadow: "none",
                      // borderColor: "#d0d5dd",
                    },
                  }}
                  onClick={() => {
                    setOpenCancelAllModal(true);
                  }}
                  size="small"
                >
                  Cancel All
                </Button>
              )}
            </Box>

            <Tabs
              value={selectedShift}
              onChange={(e, val) => setSelectedShift(val)}
              textColor="primary"
              indicatorColor="primary"
              sx={{
                "& .MuiTabs-indicator": {
                  backgroundColor: "#0e204d", // Set the indicator color to dark blue
                },
              }}
            >
              {shifts.map((shift) => (
                <Tab
                  key={shift.key}
                  label={shift.label}
                  value={shift.key}
                  sx={{
                    textTransform: "none", // Prevent uppercase transformation
                    "&.Mui-selected": {
                      color: "#0e204d", // Set the color of the selected tab to dark blue
                    },
                  }}
                />
              ))}
            </Tabs>
          </Box>

          {/* Slots Section */}
          {isRescheduleMode && (
            <Box sx={{ mb: 2 }}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 600, mb: 0.5 }}
              >
                {formatRescheduleVisitTypeHeading(rescheduleSlotInfo)}
              </Typography>
              <RadioGroup
                row
                aria-label={formatRescheduleVisitTypeHeading(rescheduleSlotInfo)}
                name="reschedule_visit_type"
                value={rescheduleVisitType}
                onChange={handleRescheduleVisitTypeChange}
                disabled={
                  isRescheduleVisitTypeLoading || isChangingRescheduleVisitType
                }
              >
                <FormControlLabel
                  value="FIRST_VISIT"
                  control={<Radio />}
                  label="New Visit"
                />
                <FormControlLabel
                  value="FOLLOW_UP"
                  control={<Radio />}
                  label="Follow up Visit"
                  disabled={rescheduleNewVisitLocked}
                />
                <FormControlLabel
                  value="REPORT_VISIT"
                  control={<Radio />}
                  label="Report Visit"
                  disabled={rescheduleNewVisitLocked}
                />
              </RadioGroup>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 600, mt: 1, mb: 0.5 }}
              >
                Appointment Mode
              </Typography>
              <RadioGroup
                row
                aria-label="Appointment Mode"
                name="reschedule_appointment_mode"
                value={rescheduleMode || ""}
                onChange={(e) => setRescheduleMode(e.target.value)}
              >
                <FormControlLabel
                  value="OFFLINE"
                  control={<Radio />}
                  label="Offline / F2F"
                />
                <FormControlLabel
                  value="ONLINE"
                  control={<Radio />}
                  label="Online"
                />
              </RadioGroup>
            </Box>
          )}
          {renderSlots(apiData?.data?.[selectedShift])}
        </DialogContent>
        <DialogActions>
          <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
            {/* Buttons */}

            <Button
              variant="contained"
              sx={{
                borderRadius: "10px",
                backgroundColor: "#121959",
                color: "#fff",
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                px: { xs: 1.5, sm: 2 },
                py: { xs: 0.5, sm: 1 },
                "&:hover": {
                  backgroundColor: "#121959",
                },
              }}
              onClick={() => {
                if (initialRescheduleData) {
                  onClose();
                } else if (isRescheduleMode) {
                  resetRescheduleMode(); // back to normal mode
                  fetchDoctorAppointmentDetails();
                  setReloadCalendar((prev) => !prev);
                  fetchSlotsData(dateForAppointment);
                } else {
                  onClose(); // normal close
                }
              }}
              size="small"
            >
              {isRescheduleMode ? "Cancel" : "Close"}
            </Button>

            {isRescheduleMode &&
              (selectedRescheduleSlot ||
                hasRescheduleVisitTypeChanged ||
                hasRescheduleModeChanged) && (
                <Button
                  variant="contained"
                  sx={{
                    borderRadius: "10px",
                    backgroundColor: "#121959",
                    color: "#fff",
                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                    px: { xs: 1.5, sm: 2 },
                    py: { xs: 0.5, sm: 1 },
                    "&:hover": {
                      backgroundColor: "#121959",
                    },
                  }}
                  onClick={handleRescheduleAppointment}
                  size="small"
                >
                  Save Changes
                </Button>
              )}
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

const CustomDateInput = forwardRef(({ value, onClick }, ref) => (
  <div
    className="custom-date-input"
    onClick={onClick}
    ref={ref}
    style={{
      display: "flex",
      alignItems: "center",
      border: "1px solid #ccc",
      borderRadius: "20px",
      padding: "6px 12px",
      cursor: "pointer",
      gap: "6px",
      width: "fit-content",
      color: "#1c2c4c",
      fontWeight: 500,
      fontSize: "14px",
    }}
  >
    <FaCalendarAlt style={{ fontSize: "14px" }} />
    <span>{value}</span>
    <IoMdArrowDropdown style={{ fontSize: "16px", marginLeft: "4px" }} />
  </div>
));

export default DoctorSlotsModal;
